const TwitterIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M2.84157 2.88L9.87938 13.14L2.99063 21.12H4.51688L10.5534 14.1225L15.3534 21.12H21.12L13.7672 10.4016L20.2556 2.88H18.7341L13.0922 9.41625L8.60813 2.88H2.84157ZM4.66407 3.84H8.10282L19.2975 20.16H15.8588L4.66407 3.84Z" fill="#272727"/>
  </svg>
);

export default TwitterIcon;
